import type { DefaultOptionType } from "antd/es/select";

import { getParentElement } from "../../../utils/dom";
import { useFormAtom } from "../../../utils/form/formAtom/hooks";
import { FormAtom } from "../../../utils/form/formAtom/types";
import { SelectInput, SelectInputBaseProps } from "../fields/selectInput";

export type SelectOptionType<T> = (DefaultOptionType & { value: T })[];

export interface FASelectInputProps<
    T extends string | number | null,
> extends SelectInputBaseProps<T> {
    atom: FormAtom<T>;
    onChange?: (value: T) => void;
}

export function FASelectInput<T extends string | number | null>({
    atom,
    options,
    label,
    filterOption,
    onChange,
    placeholder,
    className,
    disabled = false,
    autoFocus = false,
    showSearch = false,
    getPopupContainer = getParentElement,
    dropdownMatchSelectWidth = false,
    nodeAfter,
    helpText,
}: FASelectInputProps<T>) {
    const { value, error, dispatchValue } = useFormAtom(atom);

    const handleChange = (changeValue: T) => {
        void dispatchValue(changeValue);
        onChange?.(changeValue);
    };
    return (
        <SelectInput
            value={value}
            options={options}
            error={error?.value}
            label={label}
            filterOption={filterOption}
            onChange={handleChange}
            placeholder={placeholder}
            className={className}
            disabled={disabled}
            autoFocus={autoFocus}
            showSearch={showSearch}
            getPopupContainer={getPopupContainer}
            dropdownMatchSelectWidth={dropdownMatchSelectWidth}
            nodeAfter={nodeAfter}
            helpText={helpText}
        />
    );
}
